import { FAIcon } from "./faIcon.js";
import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { HTTPService, JsonResultClass } from "../util/httpManager.js";
import { Button } from "./button.js";
import { Position } from "../../createMultipleAssignments/createMultipleAssignments.js";
import React from "react";

export class TextBox extends React.Component<TextBoxProps, TextBoxState>{
    constructor(props: TextBoxProps) {
        super(props);
        this.state = {
            value: this._sanitizeInput(props.value),
            rows: 5,
            minRows: 5,
            maxRows: 200,
        };
    }

    _ref: HTMLTextAreaElement | HTMLInputElement;

    private _sanitizeInput = (value: string, extraCheck: boolean = false): string => {
        if (Helper.hasValue(value)) {
            let res = String(value).replace(/\0/g, '');
            if (extraCheck && this.props.field?.sanitizeHtml === true) {
                res = Helper.sanitizeHtml(res);
            }
            return res;
        } else {
            return '';
        }
    }


    componentDidUpdate(prevProps: TextBoxProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this._sanitizeInput(this.props.value) });
        }
    }

    handleChange = (e) => {
        if (this.props.field.triggerOnChange) {
            this.props.onChange(this.props.field, this._sanitizeInput(e.target.value), null);
            this.setState({ value: this._sanitizeInput(e.target.value) });
        } else {
            this.setState({ value: this._sanitizeInput(e.target.value) });
        }
    }


    handleBlur = (e) => {
        if (!this.props.field.triggerOnChange && this.props.value != this.state.value) 
            this.props.onChange(this.props.field, this._sanitizeInput(this.state.value, true), null);
    }

    handleFocus = (e) => {
        if (!(typeof (this.props.onFocus) == 'undefined')) {
            this.props.onFocus(e);
        }
    }

    private _handleKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
        if (this.props.onKeyPress)
            this.props.onKeyPress(e);
    }


    private _handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
        if (this.props.onKeyDown)
            this.props.onKeyDown(e);
    }

    udpateFocus = () => {
        this._ref.focus();
    }

    handleCorrectTextClicked = async () => {
        const result = await HTTPService.post<string>("ChatGPT/CorrectText", { text: this.state.value });
        const parsed = JSON.parse(result);
        this.setState({ value: parsed["correctedText"] });
    }

    handleTranslateClicked = async () => {
        const result = await HTTPService.post<string>("ChatGPT/Translate", { text: this.state.value });
        const parsed = JSON.parse(result);
        this.setState({ value: parsed["translatedText"] });
    }
    handleFormulateClicked = async () => {
        const result = await HTTPService.post<string>("ChatGPT/Formulate", { text: this.state.value });
        const parsed = JSON.parse(result);
        this.setState({ value: parsed["formulatedText"] });
    }

    render() {

        let input;
        if (this.props.field.multiLine === true) {
            const correctSpelling = this.props.field.enableChatGPTCorrect ?
                <tr><Button title="correct spelling" iconName="fal fa-check-square" iconStyle={{ color: "white" }} handleClick={this.handleCorrectTextClicked} buttonStyle={{
                    //TODO: iconStyle Color noch anpassen an helle Primärfarben
                    display: "inline-flex", zIndex: 1, border: "none", borderRadius: "50%", height: "30px", width: "30px", backgroundColor: "var(--primary-color)"
                }} /></tr>
                : null;
            const translate = this.props.field.enableChatGPTTranslate ?
                <tr><Button title="translate to english" iconName="fal fa-language fa-fw" iconStyle={{ color: "white" }} handleClick={this.handleTranslateClicked} buttonStyle={{
                    display: "inline-flex", zIndex: 1, border: "none", borderRadius: "50%", height: "30px", width: "30px", backgroundColor: "var(--primary-color)"
                }} /></tr>
                : null;
            const formulate = this.props.field.enableChatGPTFormulate ?
                <tr><Button title="form sentences" iconName="edit" iconStyle={{ color: "white" }} handleClick={this.handleFormulateClicked} buttonStyle={{
                    display: "inline-flex", zIndex: 1, border: "none", borderRadius: "50%", height: "30px", width: "30px", backgroundColor: "var(--primary-color)"
                }} /></tr>
                : null;
            let height = Helper.hasValue(this.props.textAreaHeight) ? this.props.textAreaHeight : Helper.getValueOrDefault(this.props.field.textAreaHeight, "300px");
            input = (
                <>
                    <span className="k-input k-textarea k-input-solid k-input-md k-rounded-md k-resize-none k-valid" data-readonly={this.props.disabled}>
                        <textarea
                            ref={(r) => { this._ref = r }}
                            className="!k-overflow-auto k-input-inner"
                            autoFocus={this.props.field.focus}
                            name={this.props.field.name}
                            style={{
                                height: height,
                                minHeight: height,
                                width: "100%",
                                minWidth: "100%",
                                maxWidth: "100%",
                                resize: this.props.field.textAreaResize ?? "unset",
                                textIndent: Helper.hasValue(this.props.field.faIconName) ? "24px" : "",
                                paddingRight: this.props.field.enableChatGPTCorrect || this.props.field.enableChatGPTFormulate || this.props.field.enableChatGPTTranslate ? "50px" : "0px"
                            }}
                            value={this.state.value || ""}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            onFocus={this.handleFocus}
                            onKeyPress={this._handleKeyPress}
                            onKeyDown={this._handleKeyDown}
                            required={this.props.required}
                            readOnly={this.props.disabled}
                            maxLength={this.props.field.maxLength} />
                        <table style={{ display: "inline-flex", position: "relative", flexDirection: "column", gap: "10px", right: "40px", top: "10px", zIndex: 1 }}>
                            {correctSpelling}
                            {translate}
                            {formulate}
                        </table>
                    </span>

                </>
            );
        }
        else {
            let autocomplete = "off";
            if (this.props.field.isNewPassword)
                autocomplete = "new-password"
            else if (this.props.field.isPassword)
                autocomplete = "current-password";

            input = <span className="k-input k-textbox k-input-solid k-input-md k-rounded-md" data-readonly={this.props.disabled}>

                <input ref={(r) => { this._ref = r }} className="k-input-inner" autoFocus={this.props.field.focus}
                    name={this.props.field.model} style={{
                        width: "100%",
                        textIndent: Helper.hasValue(this.props.field.faIconName) ? "24px" : ""
                    }}
                    data-label={this.props.field.name}
                    value={this.state.value || ""} onChange={this.handleChange} onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onKeyDown={this._handleKeyDown}
                    required={this.props.required} readOnly={this.props.disabled}
                    maxLength={this.props.field.maxLength} autoComplete={autocomplete}
                    type={this.props.field.isPassword === true ? "password" : this.props.field.numbersOnly ? "number" : "text"}
                    placeholder={Helper.isNullOrEmpty(this.props.field.placeholder) ? "" : this.props.field.placeholder}
                />
            </span>
        }

        // Icon auf TextBox darstellen
        if (Helper.hasValue(this.props.field.faIconName)) {
            var div =
                <div style={{ position: "relative" }}>
                    <FAIcon name={this.props.field.faIconName} sameWidth={true} style={{ zIndex: 1, color: "B5BAC5", position: "absolute", top: "10px", left: "5px" }}></FAIcon>
                    {input}
                </div>;
            return div;
        }
        else {
            return input
        }
    }
};

export interface TextBoxProps extends BaseComponentProps {
    field: TextBoxField;
    withIcon?: boolean;
    iconName?: string;
    textAreaHeight?: string;
    onFocus?(e: any);
    onKeyPress?(e: React.KeyboardEvent<HTMLElement>);
    onKeyDown?(e: React.KeyboardEvent<HTMLElement>);
    
}

export interface TextBoxState {
    value: any,
    rows: number,
    minRows: number,
    maxRows: number
}

export interface TextBoxField extends BaseField {
    isPassword?: boolean;
    isNewPassword?: boolean;
    maxLength?: number;
    multiLine?: boolean;
    triggerOnChange?: boolean;
    textAreaHeight?: string;
    textAreaResize?: any;
    faIconName?: string;
    focus?: boolean;
    placeholder?: string;
    numbersOnly?: boolean;
    enableChatGPTCorrect?: boolean;
    enableChatGPTTranslate?: boolean;
    enableChatGPTFormulate?: boolean;
    sanitizeHtml?: boolean;
}